import { render, staticRenderFns } from "./HoursFormItem.vue?vue&type=template&id=0684b470&scoped=true"
import script from "./HoursFormItem.vue?vue&type=script&lang=js"
export * from "./HoursFormItem.vue?vue&type=script&lang=js"
import style0 from "./HoursFormItem.vue?vue&type=style&index=0&id=0684b470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684b470",
  null
  
)

export default component.exports